import {z} from '@hono/zod-openapi';

export const VoiceDebugTerminalOutcomeSchema = z
  .enum([
    'budget-exhausted',
    'deadline',
    'tangent',
    'scenario-complete',
    'technical-failure',
    'caller-hangup',
    'no-progress',
  ])
  .openapi('VoiceDebugTerminalOutcomeSchema');

export type VoiceDebugTerminalOutcome = z.infer<typeof VoiceDebugTerminalOutcomeSchema>;
